import * as Messages from '../../constants/User/Messages'
import axios from 'axios';
import * as SG from '../../constants/AppSettings'
import { loadEnd, loadStart, noticeAdd} from '../App'

export function getMessageRoomList() {
  return dispatch => {
    dispatch(loadStart())

    axios.get(SG.USER_MESSAGE_ROOM_INDEX_URL, {
      headers: {
      'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      dispatch(getMessageRoomListResult(res.data.rooms))
      dispatch(loadEnd())
      }).catch(res => {
        dispatch(getMessageRoomListResult(false))
        dispatch(noticeAdd('読み込みエラー', 'error'))
        dispatch(loadEnd())
    })
  }

}

export function getMessageRoomListResult(result) {
  return {
    type: Messages.GET_MESSAGE_ROOM_INDEX_RESULT,
    result: result
  }
}

export function getMessageRoomReset() {
  return {
    type: Messages.GET_MESSAGE_ROOM_RESET
  }
}

export function getChats(anotherUserId) {
  return dispatch => {
    axios.get(SG.USER_MESSAGES_INDEX_URL.replace(/:id/, anotherUserId), {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
    }).then(res => {
        dispatch(getChatsResult(res.data))
    }).catch(res => {
      dispatch(getChatsResult(false))
      dispatch(noticeAdd('メッセージを取得出来ませんでした','error'))
    })
  }
}

export function getChatsResult(response) {
  return {
    type: Messages.GET_MESSAGES_RESULT,
    response
  }
}

export function getChatsReset() {
  return {
    type: Messages.GET_MESSAGES_RESET
  }
}

export function sendMessage(content, userId) {
  return dispatch => {
    axios.post(SG.USER_MESSAGES_CREATE, {
      chat: {
        content: content,
        receiver_id: userId
      }
    },{
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      dispatch(getChats(userId))
      dispatch(noticeAdd('メッセージを送信しました', 'success'))
    }).catch(res => {
      dispatch(noticeAdd(res.response.messages, 'errors'))
    })
  }
}

export function readAllMessage(anotherUserId) {
  return dispatch => {
    axios.post(SG.USER_MESSAGES_READ_URL.replace(/:id/, anotherUserId), {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
    }).catch(res => {
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/User/Messages.js